import { render, staticRenderFns } from "./ExerciciosQuestoesPergunta.vue?vue&type=template&id=45f57fe4&"
import script from "./ExerciciosQuestoesPergunta.vue?vue&type=script&lang=js&"
export * from "./ExerciciosQuestoesPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports